import React, { createRef, FC, useEffect, useRef, useState } from "react";
import { Button, Col, Row, Spin, Tooltip, Typography } from "antd";
import moment from "moment";
// import Avatar from "antd/lib/avatar/avatar";
import { cloneDeep, get, head, forEach, find, isEmpty, noop, sortBy } from "lodash";
import InfiniteLoader from "react-window-infinite-loader";
import { FixedSizeList as List } from "react-window";

import membersService from "@services/members.service";
import { IMembers } from "@pages/members/constants";
import { ADD, EDIT, MEMBERS_DETAILS_SCREEN_TITLE, MEMBERS_SCREEN_TITLE, MEMBER_DETAILS_LOCAL, MEMBER_LIST_GLOBAL } from "@utils/constants";
import { formatDisplayDate, localToUTCFormatDate, milleniumClientCheck } from "@utils/helpers";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import "./drawerCalendar.scss";
import { CanEdit } from "@components/accessLevel";
import {
  USER_ACTION_MODULE_MEMBER_LIST,
  USER_ACTION_TAB_GLOBAL,
  USER_ACTION_CARD_RIGHT_NAVIGATION,
  USER_ACTION_LOCATION_DEFAULT,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_DESCRIPTION_REMINDER_SAVE,
  USER_ACTION_DESCRIPTION_REMINDER_UPDATE,
  USER_ACTION_DESCRIPTION_REMINDER_DELETE,
  CASE_STATUS_REASON_REMINDER,
  // REMINDER_SUCCESSFUL_VALUE,
  // REMINDER_UNSUCCESSFUL_VALUE,
  // REMINDER_NO_ACTION,
  // PAST,
} from "@utils/constants";
import ReminderForm from "../reminder/reminderForm/reminderForm";
import DataNotFound from "@components/noDataFound";
import { NO_UPCOMING_REMINDER } from "../../constants/constants";
import { ReminderHeader } from "./HeaderView";
import { TReminder, useRemindersContext } from "./useReminders";
import { currentAndUpcomingReminderDOM_Height, DAY } from "./constant";
import { useMembersContext } from "@pages/members/useMembers";
import { ReminderGridView } from "./calenderViews/gridView";
import { CURRENT_ITEM } from "@components/reminder/constants";
import { AllDayCadences } from "@components/drawerOutreaches/Cadence";

const { Text } = Typography;

type TDrawerCalendarProps = {
  members: IMembers[];
  updateMembers: any;
  updateStatus?: any;
  rightDrawerCloseHandler: any;
};

const calenderStartTime = 0;
const calenderEndTime = 23;

const getTimeline = () => {
  let arr = [];
  for (let index = calenderStartTime; index <= calenderEndTime; index++) {
    arr.push(index === 12 ? "12 PM" : index > 12 ? `${index - 12} PM` : `${index} AM`);
  }
  return arr;
};

const DrawerCalendar: FC<TDrawerCalendarProps> = ({ members, updateMembers, updateStatus, rightDrawerCloseHandler }) => {
  const {
    upcomingReminders,
    currentScreen,
    selectDate,
    setSelectDate,
    getReminderDates,
    getReminderDataForKPI,
    fetchFirstCurrentAndUpcomingReminders,
    fetchCurrentAndUpcomingReminders,
    fetchRemindersBasedOnView,
    getReminders,
    globalLoader,
    setGlobalLoader,
    todaysReminder,
    setTodaysReminder,
  } = useRemindersContext();
  const { sidebarExpand } = useMembersContext();
  //Store State
  const updatedReminder = useCareCoordinationStore((state) => state.updatedReminder);
  const setUpdatedReminder = useCareCoordinationStore((state) => state.setUpdatedReminder);
  const setMemberDetailGlobalReminder = useGlobalInformationStore((state) => state.setMemberDetailGlobalReminder);

  const [showAddReminder, setShowAddReminder] = useState(false);
  const [editReminder, setEditReminder] = useState<any>({});
  const [action, updateAction] = useState(false);
  const [editMode, setEditMode] = useState<any>(false);

  const currentTimeLine = createRef<any>();

  const [page, setPage] = useState<number>(1);

  // Lazy Loading current and upcoming reminders utility functions
  const loadNextFutureReminders = () => {
    if (upcomingReminders?.currentAndfutureReminders?.length < upcomingReminders?.totalFutureReminders) {
      const nextPage: number = page + 1;
      setPage(nextPage);
      fetchCurrentAndUpcomingReminders(nextPage);
    }
  };

  // Calling reminder KPI stats and current and upcoming reminders lazy loaded data for syncing
  const onReminderCRUD_operation_forUpcomingReminders = () => {
    setPage(1);
    getReminderDataForKPI();
    fetchFirstCurrentAndUpcomingReminders();
  };

  function cancelClickHandler(){
    setShowAddReminder(false);
    setEditMode(false);
  };

  // Lazy loaded current and upcoming reminder DOM
  const upComingReminder: any = (props: any) => {
    const _upcomingReminder = get(upcomingReminders, `currentAndfutureReminders.[${props?.index}]`, {});

    const { patientName, reminderStartDate, reminderEndDate, reminderTitle } = _upcomingReminder;

    return !isEmpty(_upcomingReminder) ? (
      <div style={props.style} key={props?.index}>
        <div className="reminders_container_notes__reminder" onClick={() => upcomingReminderClick(_upcomingReminder)}>
          <div className="reminders_container_notes__reminder__content">
            <Tooltip title={patientName || reminderTitle}>
              <div className={`f16 fw500 blue-color cursor-type--pointer ${!patientName ? 'clr-black' : ''}`}>{patientName || reminderTitle}</div>
            </Tooltip>
            <p className="reminders_container_notes__reminder__content__timingData">
              <div className="date">{`${formatDisplayDate(reminderStartDate, "reminderDateActualFormat", "formatDateForReminder", true)} `}</div>
              <div className="divider">|</div>
              <div className="time">{` ${formatDisplayDate(reminderStartDate, "reminderDateActualFormat", "formatTimeForReminder", true)}  to 
                          ${formatDisplayDate(reminderEndDate, "reminderDateActualFormat", "formatTimeForReminder", true)}`}</div>
            </p>
          </div>
        </div>
      </div>
    ) : null;
  };

  /////////////////////////////////////////////////////////
  //#######################################################
  /////////////////////////////////////////////////////////

  // Updating member list handler
  const updateMemberList = (cc: any) => {
    if (updateMembers) {
      updateMembers([]);
      updateMembers(cc);
    } else {
      updateAction(!action);
    }
  };

  const afterSave = (saved: any, isAdd: boolean, recurredReminders: any = {}) => {
    const copy = [...members];
    let updateStatusCount = 0;
    const cc = copy.map((p: IMembers) => {
      forEach(saved, (item: any) => {
        if (p.patient_id === item?.patientId) {
          let copyRem: any = [...(p.reminders || [])];
          let reminder = {
            reminderId: item?.reminderId,
            reminderStartDate: item?.reminderStartDate,
            reminderEndDate: item?.reminderEndDate,
            patientId: p.patient_id,
            patientName: p.patient_name,
            reminder: item?.reminder,
            reminderCreatedBy: item?.reminderCreatedBy,
            recurrence: item?.recurrence,
            parentReminderId: item?.parentReminderId,
            reminderStatus: item?.reminderStatus,
            reminderTitle: item?.reminderTitle,
          };
          if (isAdd) {
            copyRem.push(reminder);
            p.reminders = copyRem;
            const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
              USER_ACTION_DESCRIPTION_REMINDER_SAVE,
              CASE_STATUS_REASON_REMINDER
            );
            if (updateStatusCount <= 0) {
              updateStatus(p, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
              updateStatusCount += 1;
            }
          } else {
            if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
              let copyupdatedReminder = cloneDeep(updatedReminder);
              let updateReminderFlag = false;
              copyupdatedReminder.editedReminder = updatedReminder.editedReminder.map((tempReminder: any, index: any) => {
                let copyTempReminder = tempReminder;
                if (Number(tempReminder.reminderId) === Number(reminder.reminderId)) {
                  updateReminderFlag = true;
                  copyTempReminder = { ...reminder };
                }
                return copyTempReminder;
              });
              if (!updateReminderFlag) copyupdatedReminder.editedReminder.push(reminder);
              setUpdatedReminder(copyupdatedReminder);
            }

            p.reminders = copyRem.map((rem: any) => {
              return rem.reminderId === editReminder.reminderId ? reminder : rem;
            });
            const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
              USER_ACTION_DESCRIPTION_REMINDER_UPDATE,
              CASE_STATUS_REASON_REMINDER
            );
            if (updateStatusCount <= 0) {
              updateStatus(p, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
              updateStatusCount += 1;
            }
          }
        }
      });

      if (recurredReminders?.patientId === p.patient_id && !isEmpty(recurredReminders)) {
        let copyRem: any = [...(p.reminders || [])];
        let copyupdatedReminder = cloneDeep(updatedReminder);

        if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
          let updateReminderFlag = false;

          if (recurredReminders?.deletedReminders && recurredReminders?.deletedReminders.length > 0) {
            forEach(recurredReminders?.deletedReminders, (delRem: any) => {
              if (copyupdatedReminder.deletedReminder.includes(Number(delRem?.reminderId))) {
                updateReminderFlag = true;
              }
              if (!updateReminderFlag) copyupdatedReminder.deletedReminder.push(Number(delRem?.reminderId));
            });
          }
          setUpdatedReminder(copyupdatedReminder);
        } else {
          if (recurredReminders?.deletedReminders && recurredReminders?.deletedReminders.length > 0) {
            copyRem = copyRem?.filter((item: any) => {
              return !find(recurredReminders?.deletedReminders, { reminderId: item?.reminderId });
            });
          }
          if (recurredReminders?.newReminders && recurredReminders?.newReminders.length > 0) copyRem = [...cloneDeep(copyRem), ...cloneDeep(recurredReminders?.newReminders)];
          p.reminders = copyRem;
          const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
            USER_ACTION_DESCRIPTION_REMINDER_UPDATE,
            CASE_STATUS_REASON_REMINDER
          );
          if (updateStatusCount <= 0) {
            updateStatus(p, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
            updateStatusCount += 1;
          }
        }
      }
      return p;
    });
    updateMemberList(cc);
  };

  const editReminderHandler = (reminder: any, loaderCallback: any) => {
    console.log("DrawerCalendar.editReminderHandler");
    setGlobalLoader(true);
    let reminderType = "";
    switch (currentScreen) {
      case MEMBERS_SCREEN_TITLE:
        reminderType = MEMBER_LIST_GLOBAL;
        break;
      case MEMBERS_DETAILS_SCREEN_TITLE:
        reminderType = MEMBER_DETAILS_LOCAL;
        break;
      default:
        reminderType = "";
    }
    if (reminder?.reminderId) {
      let reminderCopy = {
        patientId: reminder.patientId,
        reminderStartDate: reminder?.reminderStartDate ? localToUTCFormatDate(reminder?.reminderStartDate) : null,
        reminderEndDate: reminder?.reminderEndDate ? localToUTCFormatDate(reminder?.reminderEndDate) : null,
        reminder: reminder?.reminder,
        reminderId: reminder?.reminderId,
        reminderType: reminderType,
        recurrence: reminder?.recurrence,
        reminderStatus: reminder?.reminderStatus,
        prevReminderStartDate: reminder?.prevReminderStartDate,
        parentReminderId: reminder.parentReminderId,
        reminderTitle: reminder?.reminderTitle,
        timeZoneOffset: reminder?.timeZoneOffset
      };
      membersService.editReminder(reminderCopy).subscribe({
        next: (res) => {
          setGlobalLoader(false);
          const updatedReminderList = res?.data?.data?.reminder?.updatedReminderList;
          const deletedReminderLIst = res?.data?.data?.reminder?.deactivatedReminders;
          const newReminderList = res?.data?.data?.reminder?.newlyCreatedReminders;

          let _remindersList = cloneDeep(todaysReminder);
          let newDataForReminders: any[] = [];

          if(deletedReminderLIst && deletedReminderLIst?.length) {
            _remindersList = _remindersList?.filter((item:any) => !find(deletedReminderLIst, {reminderId : item?.reminderId}))
          }

          if(newReminderList && newReminderList?.length) {
            _remindersList = [..._remindersList, ...newReminderList?.filter(
              (item: any) => moment(selectDate).format("YYYY-MM-DD") === formatDisplayDate(item?.reminderStartDate, "reminderDateActualFormat", "createDateFormat", true)
            )]
          }
          if(((deletedReminderLIst && deletedReminderLIst?.length) || (newReminderList && newReminderList?.length)) && reminderCopy?.patientId) {
            afterSave([], false, { recurrence: true, patientId: reminder?.patientId, deletedReminders: deletedReminderLIst, newReminders: newReminderList });
          }

          if(updatedReminderList && updatedReminderList?.length) {
            _remindersList = _remindersList.map((item:any) => {
              let temp = cloneDeep(item);
              const findItem = find(updatedReminderList, {reminderId : item?.reminderId})
              if(findItem) {
                temp = {
                  ...temp,
                  ...findItem
                }
              }
              return temp
            });
            if(reminderCopy?.patientId) {
              afterSave(updatedReminderList, false);
            }
          }

          onReminderCRUD_operation_forUpcomingReminders();
          newDataForReminders = _remindersList?.filter(
            (item: any) => moment(selectDate).format("YYYY-MM-DD") === formatDisplayDate(item?.reminderStartDate, "reminderDateActualFormat", "createDateFormat", true)
          );

          newDataForReminders = sortBy(newDataForReminders, "reminderStartDate");

          setTodaysReminder(newDataForReminders);
          setMemberDetailGlobalReminder(newDataForReminders);
          cancelClickHandler();
          loaderCallback();
        },
        error: () => {
          setGlobalLoader(false);
          loaderCallback();
        },
      });
    }
  };

  const addReminder = (reminder: any, loaderCallback: any) => {
    console.log("DrawerCalendar.addReminder");
    setGlobalLoader(true);
    let reminderType = "";
    switch (currentScreen) {
      case MEMBERS_SCREEN_TITLE:
        reminderType = MEMBER_LIST_GLOBAL;
        break;
      case MEMBERS_DETAILS_SCREEN_TITLE:
        reminderType = MEMBER_DETAILS_LOCAL;
        break;
      default:
        reminderType = "";
    }
    membersService
      .addReminder(
        reminder?.patientId,
        reminder?.reminderStartDate,
        reminder?.reminderEndDate,
        reminder?.description,
        reminder?.recurrence,
        {
          reminderType: reminderType,
        },
        reminder?.patientName,
        reminder?.reminderTitle
      )
      .subscribe({
        next: (res) => {
          setTodaysReminder([]);
          setGlobalLoader(false);
          let saved = res?.data?.data.reminder;

          let cc: TReminder[] = [
            ...todaysReminder,
            ...saved
              ?.filter((reminder: any) => moment.utc(reminder?.reminderStartDate).local().format("YYYY-MM-DD") === selectDate.format("YYYY-MM-DD"))
              .map((item: any) => {
                return { ...item, patientName: reminder?.patientName };
              }),
          ];
          onReminderCRUD_operation_forUpcomingReminders();
          setTodaysReminder(cc);
          setMemberDetailGlobalReminder(cc);
          afterSave(saved, true);
          cancelClickHandler();
          loaderCallback();
        },
        error: () => {
          loaderCallback();
          setGlobalLoader(false);
        },
      });
  };

  const deleteReminderHandler = (reminder : any , loaderCallback : any =  noop, operationRange = CURRENT_ITEM) => {
    console.log("DrawerCalendar.deleteReminderHandler");
    setGlobalLoader(true);
    membersService.deleteReminder(reminder?.reminderId , reminder?.parentReminderId , reminder?.reminderStartDate , operationRange).subscribe({
      next: (res) => {
        setGlobalLoader(false);
        const copy = [...members];
        const cc = copy.map((p: IMembers) => {
          if (p.patient_id === reminder?.patientId) {
            let copyRem: any = [...(p.reminders || [])].filter((rem: any) => rem?.reminderId !== reminder?.reminderId);
            p.reminders = copyRem;
            const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
              USER_ACTION_DESCRIPTION_REMINDER_DELETE,
              CASE_STATUS_REASON_REMINDER
            );
            updateStatus(p, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
          }
          return p;
        });
        const cc1: TReminder[] = [...todaysReminder].filter((rem) => rem.reminderId !== reminder?.reminderId);

        onReminderCRUD_operation_forUpcomingReminders();

        setTodaysReminder(cc1);
        setMemberDetailGlobalReminder(cc1);
        updateMemberList(cc);
        cancelClickHandler();

        if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
          let copyupdatedReminder = cloneDeep(updatedReminder);
          let updateReminderFlag = false;
          if (copyupdatedReminder.deletedReminder.includes(Number(reminder?.reminderId))) {
            updateReminderFlag = true;
          }
          if (!updateReminderFlag) copyupdatedReminder.deletedReminder.push(Number(reminder?.reminderId));
          setUpdatedReminder(copyupdatedReminder);
        }
        loaderCallback();
      },
      error: (err) => {
        setGlobalLoader(false);
        loaderCallback();
      },
    });
  };

  // Add reminder pop-up handler
  const addRemainder = () => {
    setShowAddReminder(true);
    if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
      setEditReminder({ patientId: head(members)?.patient_id, patientName: head(members)?.patient_name });
    } else {
      setEditReminder({});
    }
  };

  const upcomingReminderClick = (rem: any) => {
    // setSelectedDate(moment(rem.reminderStartDate));
    setSelectDate(moment(rem.reminderStartDate));
    //On Selection of reminder we send a callback back function which scrolls to the reminder
    getReminders([moment.utc(rem.reminderStartDate).local().format("YYYY-MM-DD"), moment.utc(rem.reminderStartDate).local().format("YYYY-MM-DD")], () => {
      setTimeout(() => {
        document?.getElementById(`event-container-${rem.reminderStartDate}-${rem.reminderEndDate}`)?.scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }, 400);
    });
  };

  /////////////////////////////////////////////////////////
  //#######################################################
  /////////////////////////////////////////////////////////

  // Reminder position utility functions ( Calendar )

  const getStartPosition = (from: any) => {
    const date = moment(from);
    const hr = date.hour();
    const min = date.minute();
    return hr * 60 + min - 40;
  };

  const getDuration = (from: any, to: any) => {
    const fromDate = moment(from);
    const toDate = moment(to);
    return toDate.diff(fromDate, "minutes");
  };

  const getWidth = (from: any, to: any, reminderId: any) => {
    let count = [...todaysReminder].filter((rem: any) => {
      return (
        moment.utc(from).format("YYYY-MM-DD HH:mm:ss") <= moment.utc(rem.reminderEndDate).format("YYYY-MM-DD HH:mm:ss") &&
        moment.utc(to).format("YYYY-MM-DD HH:mm:ss") >= moment.utc(rem.reminderStartDate).format("YYYY-MM-DD HH:mm:ss") &&
        reminderId !== rem.reminderId
      );
    }).length;
    return count > 0 ? 100 / (count + 1) : 100;
  };

  const getLeft = (from: any, to: any, reminderId: any) => {
    const w = getWidth(from, to, reminderId);
    const overlappedRem = [...todaysReminder].filter((rem: any) => {
      return (
        moment.utc(from).format("YYYY-MM-DD HH:mm:ss") <= moment.utc(rem.reminderEndDate).format("YYYY-MM-DD HH:mm:ss") &&
        moment.utc(to).format("YYYY-MM-DD HH:mm:ss") >= moment.utc(rem.reminderStartDate).format("YYYY-MM-DD HH:mm:ss")
      );
    });
    return w === 100 ? 0 : w * overlappedRem.findIndex((rem) => rem.reminderId === reminderId);
  };

  /////////////////////////////////////////////////////////
  //#######################################################
  /////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////
  //#######################################################
  /////////////////////////////////////////////////////////

  const onEventClick = (event: any) => {
    setEditMode(true);
    setEditReminder(event);
    setSelectDate(moment(event?.reminderStartDate));
    setShowAddReminder(true);
  };

  const getUserActionParams = (userActionDescription: any, reason: any) => {
    let props;
    switch (currentScreen) {
      case MEMBERS_SCREEN_TITLE:
        props = {
          caseStatusReasonTxt: reason,
          actionModule: USER_ACTION_MODULE_MEMBER_LIST,
          actionTab: USER_ACTION_TAB_GLOBAL,
          actionCard: USER_ACTION_CARD_RIGHT_NAVIGATION,
          actionLocation: USER_ACTION_LOCATION_DEFAULT,
          actionDescription: userActionDescription,
        };
        break;
      case MEMBERS_DETAILS_SCREEN_TITLE:
        props = {
          caseStatusReasonTxt: reason,
          actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
          actionTab: USER_ACTION_TAB_GLOBAL,
          actionCard: USER_ACTION_CARD_RIGHT_NAVIGATION,
          actionLocation: USER_ACTION_LOCATION_DEFAULT,
          actionDescription: userActionDescription,
        };
        break;
      default:
        props = {};
    }
    return props;
  };

  // To populate reminder KPI stats
  // const getReminderStats = () => {
  //   const stats: any = {
  //     success: 0,
  //     unSuccessful: 0,
  //     noAction: 0,
  //   };

  //   forEach(KPIreminderData, (item: any) => {
  //     if (item?.reminderStatus === REMINDER_SUCCESSFUL_VALUE) {
  //       stats[REMINDER_SUCCESSFUL_VALUE] += 1;
  //     } else if (item?.reminderStatus === REMINDER_UNSUCCESSFUL_VALUE) {
  //       stats[REMINDER_UNSUCCESSFUL_VALUE] += 1;
  //     } else {
  //       stats[REMINDER_NO_ACTION] += 1;
  //     }
  //   });
  //   return stats;
  // };

  /////////////////////////////////////////////////////////
  //#######################################################
  /////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////
  //#######################################################
  /////////////////////////////////////////////////////////

  // USE EFFECT

  useEffect(() => {
    console.log("DrawerCalendar.useEffect2");

    fetchRemindersBasedOnView({view :  DAY});
    getReminderDates();
    fetchFirstCurrentAndUpcomingReminders();
    getReminderDataForKPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("DrawerCalendar.useEffect2");
    //the below call is to update the upcoming reminders in timeline view of reminders
    if(sidebarExpand === false) {
      fetchFirstCurrentAndUpcomingReminders();
    } else {
      cancelClickHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebarExpand]);

  useEffect(() => {
    console.log("DrawerCalendar.useEffect3");
    currentTimeLine?.current?.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [todaysReminder]);

  /////////////////////////////////////////////////////////
  //#######################################################
  /////////////////////////////////////////////////////////

  return (
    <Spin spinning={globalLoader} indicator={<HealthemSpinner size={45} />}>
      <div className="reminder-wrapper">
        <ReminderHeader {...{ closeDrawer: rightDrawerCloseHandler }} />
        {!sidebarExpand ? (
          <ReminderTimeView
            {...{
              todaysReminder,
              getDuration,
              getStartPosition,
              getWidth,
              getLeft,
              onEventClick,
              addReminder,
              editReminderHandler,
              deleteReminderHandler,
              editReminder,
              setEditReminder,
              currentTimeLine,
              showAddReminder,
              cancelClickHandler,
              editMode,
              addRemainder,
              loadNextFutureReminders,
              upComingReminder,
            }}
          />
        ) : (
          <ReminderGridView {...{ members, updateMembers, updateStatus }} />
        )}
      </div>
    </Spin>
  );
};


function ReminderTimeView({
  todaysReminder,
  getDuration,
  getStartPosition,
  getWidth,
  getLeft,
  onEventClick,
  addReminder,
  editReminderHandler,
  deleteReminderHandler,
  editReminder,
  setEditReminder,
  currentTimeLine,
  showAddReminder,
  cancelClickHandler,
  editMode,
  addRemainder,
  loadNextFutureReminders,
  upComingReminder,
}: any) {
  const { upcomingReminders, futureReminderLoader, currentScreen, selectDate, viewType } = useRemindersContext();

  return (
    <div className="reminders_container">
      <div className="reminders_container__one">
        <div className="reminders_container_events">
          <Row className="reminder-calender-wrapper-container custom-scroll-bar">
            <Col span={24}>
              <div className="calender-timeline">
                {/* <div className="gmt-details">GMT {moment().local().format("Z")}</div> */}
                {viewType === DAY ? (
                  <div className="reminder-daily">
                    <table className="timing-table">
                      <tbody>
                        {
                          milleniumClientCheck() &&
                          <tr>
                            <td className="timing-table__allday">
                            </td>
                          </tr>
                        }
                        <tr>
                          <td>
                            {getTimeline().map((time) => {
                              return <div className="timing-label">{time === "0 AM" ? "12 AM" : time}</div>;
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="event-table">
                      <tbody>
                        {
                          milleniumClientCheck() &&
                          <tr>
                            <td className="timing-table__allday">
                              <AllDayCadences view={DAY} date={selectDate} />
                            </td>
                          </tr>
                        }
                        <tr>
                          <td>
                            {getTimeline().map((time) => (
                              <>
                                <div
                                  className="event-item"
                                  // onClick={() =>
                                  //   moment() < moment(moment(selectedDate).format("YYYY-MM-DD") + " " + timeConversion(time)).add(30, "minutes") ? remainderTimeClicked(timeConversion(time)) : null
                                  // }
                                ></div>
                                <div
                                  className="event-item-b"
                                  // onClick={() =>
                                  //   moment() < moment(moment(selectedDate).format("YYYY-MM-DD") + " " + timeConversion(time)).add(30, "minutes")
                                  //     ? remainderTimeClicked(timeConversion(time, false))
                                  //     : null
                                  // }
                                ></div>
                              </>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="reminder-events">
                      {todaysReminder?.map((e: any) => {
                        return (
                          <Reminder
                            e={e}
                            getDuration={getDuration}
                            getStartPosition={getStartPosition}
                            getWidth={getWidth}
                            getLeft={getLeft}
                            onEventClick={onEventClick}
                            reminderList={todaysReminder}
                            addReminder={addReminder}
                            editReminder={editReminderHandler}
                            deleteReminder={deleteReminderHandler}
                            reminderToBeEdited={editReminder}
                            setReminderToBeEdited={setEditReminder}
                          />
                        );
                      })}
                    </div>
                    <div
                      ref={currentTimeLine}
                      className="current-time-line"
                      style={{
                        transform: `translateY(${getStartPosition(moment()) - 1}px)`,
                      }}
                    ></div>
                  </div>
                ) : (
                  <div className="reminder-weekly"></div>
                )}
              </div>
            </Col>
          </Row>
          {showAddReminder && (
            <div className="reminderForm">
              <div className="reminderForm__backDrop" />
              <ReminderForm
                action={editMode ? EDIT : ADD}
                date={selectDate}
                reminder={editReminder}
                closeReminderForm={cancelClickHandler}
                showSearch={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode ? false : true}
                allowClear={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode ? false : true}
                addReminder={addReminder}
                editReminder={editReminderHandler}
                deleteReminder={deleteReminderHandler}
                listOfReminders={todaysReminder}
              />
            </div>
          )}
        </div>
        <CanEdit>
          {moment(selectDate).isSameOrAfter(moment().format("YYYY-MM-DD")) ? (
            <div className="floating-add-button">
              <Button type="primary" shape="circle" className="add-event" onClick={addRemainder}>
                <i className="icon icon-plus"></i>
              </Button>
            </div>
          ) : null}
        </CanEdit>
      </div>

      {upcomingReminders?.currentAndfutureReminders?.length > 0 ? (
        <div className="reminders_container_notes">
          <>
            <div className="reminders_container_notes_heading">
              <hr />
              <span>Current and Upcoming Reminders</span>
              <hr />
            </div>
            <div className="upcomingreminders">
              <Spin spinning={futureReminderLoader} indicator={<HealthemSpinner size={45} />}>
                <InfiniteLoader
                  isItemLoaded={(index) => index < upcomingReminders?.currentAndfutureReminders?.length}
                  itemCount={
                    upcomingReminders?.currentAndfutureReminders?.length < upcomingReminders?.totalFutureReminders
                      ? upcomingReminders?.currentAndfutureReminders?.length + 1
                      : upcomingReminders?.currentAndfutureReminders?.length
                  }
                  loadMoreItems={() => loadNextFutureReminders()}
                  minimumBatchSize={1}
                  threshold={1}
                >
                  {({ onItemsRendered, ref }) => (
                    <List
                      height={currentAndUpcomingReminderDOM_Height}
                      width={"100%"}
                      itemCount={
                        upcomingReminders?.currentAndfutureReminders?.length < upcomingReminders?.totalFutureReminders
                          ? upcomingReminders?.currentAndfutureReminders?.length + 1
                          : upcomingReminders?.currentAndfutureReminders?.length
                      }
                      itemSize={40}
                      onItemsRendered={onItemsRendered}
                      ref={ref}
                    >
                      {upComingReminder}
                    </List>
                  )}
                </InfiniteLoader>
              </Spin>
            </div>
          </>
        </div>
      ) : (
        <span className="reminders_container_notes_heading">
          <DataNotFound message={NO_UPCOMING_REMINDER} />
        </span>
      )}
    </div>
  );
}

const Reminder = (props: {
  e: any;
  getStartPosition: (arg0: any) => any;
  getDuration: (arg0: any, arg1: any) => number;
  getWidth: (arg0: any, arg1: any, arg2: any) => number;
  getLeft: (arg0: any, arg1: any, arg2: any) => any;
  onEventClick: (arg0: any) => void;
  reminderList: any;
  addReminder: any;
  editReminder: any;
  deleteReminder: any;
  reminderToBeEdited: any;
  setReminderToBeEdited: any;
}) => {
  const e = props.e;
  // const {addReminder, editReminder, deleteReminder, reminderToBeEdited, setReminderToBeEdited}: any = props;
  const tooltipRef = useRef(null);

  const [showLink, setShowLink] = useState(false);
  // const [showAdditionalReminderModal, setShowAdditionalReminderModal] = useState(false);
  // const [reminderFormOpen, setReminderFormOpen] = useState(false);

  useEffect(() => {
    console.log("Reminder.useEffect");
    if (get(tooltipRef, "current.clientWidth", 0) < get(tooltipRef, "current.scrollWidth", 0)) {
      setShowLink(true);
    }
  }, []);
  // const additionalReminders = props?.reminderList
  //   ?.filter((reminder: any) => moment(e.reminderStartDate).hour() === moment(reminder.reminderStartDate).hour())
  //   .sort((a: any, b: any) => (moment(a?.reminderStartDate) < moment(b?.reminderStartDate) ? -1 : 1));
  // const showAdditionalReminders =
  //   additionalReminders?.length > 2 ? additionalReminders?.filter((additionalReminder: any, index: any) => index === 0 && additionalReminder?.reminderId === e.reminderId).length > 0 : false;
  // const hideAdditionalReminders = additionalReminders?.length > 2 ? findIndex(additionalReminders, { reminderId: e.reminderId }) >= 1 : false;

  return (
    <div
      className="event-item"
      style={{
        display: "flex",
        flexDirection: "row",
        transform: `translateY(${props.getStartPosition(e.reminderStartDate)}px)`,
        height: props.getDuration(e.reminderStartDate, e.reminderEndDate) - 1,
        width: `${props.getWidth(e.reminderStartDate, e.reminderEndDate, e.reminderId) - 1}%`,
        left: `${props.getLeft(e.reminderStartDate, e.reminderEndDate, e.reminderId)}%`,
        justifyContent: "space-between",
      }}
      onClick={() => props.onEventClick(e)}
    >
      <div
        // className="event-container"
        style={{
          display: "flex",
          backgroundColor: "#e8f8f1",
          width: 0,
          height: props.getDuration(e.reminderStartDate, e.reminderEndDate) - 1,
        }}
      ></div>
      <div
        className="event-container"
        id={`event-container-${e.reminderStartDate}-${e.reminderEndDate}`}
        ref={tooltipRef}
        style={{
          display: "flex",
          flexDirection: "row",
          // background: "#fdeeed",
          backgroundColor: `${moment(e.reminderStartDate) > moment() ? "#e8f8f1" : "#EFEFF0"}`,
          width: "100%",
          height: props.getDuration(e.reminderStartDate, e.reminderEndDate) - 1 > 25 ? props.getDuration(e.reminderStartDate, e.reminderEndDate) - 1 : 25,
        }}
      >
        {showLink ? (
          <Tooltip title={e.reminder + " " + moment(e.reminderStartDate).format("hh:mm a")}>
            <div className="event-title">
              {/* {formatDisplayDate(e.reminderStartDate, "reminderDateActualFormat", "formatDateForReminder")} &nbsp; {moment(e.reminderStartDate).format("hh:mm a")} */}
              <span className={`reminder-member-name ${moment(e.reminderStartDate) > moment() ? "" : "past-reminder-member-name"}`}>{e.patientName}</span> &nbsp; | &nbsp;
              {/* <span>{e.reminder}</span> */}
              <Text
                style={
                  e.reminder?.length > 30
                    ? {
                        width: "14rem",
                      }
                    : undefined
                }
                ellipsis={e.reminder?.length > 15}
              >
                {e.reminder}
              </Text>
            </div>
          </Tooltip>
        ) : (
          <div className="event-title">
            {/* {formatDisplayDate(e.reminderStartDate , 'reminderDateActualFormat' , "formatDateForReminder")} &nbsp; {moment(e.reminderStartDate).format("hh:mm a")} */}
            <span className={`reminder-member-name ${moment(e.reminderStartDate) > moment() ? "" : "past-reminder-member-name"}`}>{e.patientName || e.reminderTitle}</span> &nbsp; | &nbsp;
            {/* <span>{e.reminder}</span> */}
            <Text
              style={
                e.reminder?.length > 30
                  ? {
                      width: "14rem",
                    }
                  : undefined
              }
              ellipsis={e.reminder?.length > 15}
            >
              {e.reminder}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default DrawerCalendar;
